// Ian - 2026-08-14 - New PDP (Aug 2026 trial). Tops "Also worth a look" up to a full row.
//
// The curated Search & Discovery picks are server-rendered by the section. This fills any
// remaining slots from Shopify's own recommendations endpoint, so the row can replace the
// theme's "Recommended For You" instead of sitting alongside it.
//
// It asks Shopify to re-render THIS section rather than fetching product JSON and building
// cards here. That matters: the topped-up cards come out of the same Liquid snippet as the
// curated ones, so the two halves of the row cannot drift apart in markup, price format or
// metre handling, and no card-building logic is duplicated in JavaScript.
//
// Everything it adds is an enhancement. The curated cards are already in the HTML and
// crawlable before this runs, and a failure here leaves a shorter row rather than a broken
// one.

if (!window.__ianPdpTopup) {
  window.__ianPdpTopup = true;

  const REMNANT = 'remnant';

  const run = async (root) => {
    const target = parseInt(root.dataset.target, 10) || 0;
    const list = root.querySelector('.ian-pdp__cards');
    if (!list || !target) return;

    const rendered = new Set(
      (root.dataset.rendered || '').split(',').map((h) => h.trim()).filter(Boolean)
    );

    let needed = target - list.children.length;
    if (needed <= 0) return;

    const params = new URLSearchParams({
      section_id: root.dataset.sectionId,
      product_id: root.dataset.productId,
      intent: 'related',
      // Ask for more than needed: some come back as duplicates of the curated picks or as
      // remnants, and both are dropped below.
      limit: String(Math.min(target + 6, 10))
    });

    let doc;
    try {
      const response = await fetch(`/recommendations/products?${params}`);
      if (!response.ok) return;
      doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    } catch (error) {
      return;
    }

    const candidates = doc.querySelectorAll('.ian-pdp__cards > li');

    for (const item of candidates) {
      if (needed <= 0) break;

      const card = item.querySelector('.ian-pdp__card');
      if (!card) continue;

      const handle = card.dataset.handle;
      const type = card.dataset.productType || '';
      const variantCount = parseInt(card.dataset.variantCount, 10) || 1;

      // Already curated above, so adding it again would show the same fabric twice.
      if (!handle || rendered.has(handle)) continue;

      // The algorithmic list for this catalogue surfaces remnants of the same fabric, which
      // is near-duplicate merchandising rather than "also worth a look".
      if (type.includes(REMNANT)) continue;

      // A multi-variant product cannot show a stepper, so it renders "Choose options" and
      // breaks the consistency of a row where every other card adds to the basket. The
      // curated picks are Sarah's call and are left alone; this only filters the
      // algorithmic filler, where there is no reason to accept an odd one out.
      if (variantCount > 1) continue;

      rendered.add(handle);
      list.appendChild(document.importNode(item, true));
      needed -= 1;
    }

    root.dataset.toppedUp = 'true';
  };

  const init = () => {
    document.querySelectorAll('[data-ian-pdp-topup]').forEach((root) => {
      if (root.dataset.toppedUp) return;
      run(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}
